"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var recaptcha_forms_module_1 = require("./recaptcha/recaptcha-forms.module");
exports.RecaptchaFormsModule = recaptcha_forms_module_1.RecaptchaFormsModule;
var recaptcha_value_accessor_directive_1 = require("./recaptcha/recaptcha-value-accessor.directive");
exports.RecaptchaValueAccessorDirective = recaptcha_value_accessor_directive_1.RecaptchaValueAccessorDirective;



//////////////////
// WEBPACK FOOTER
// G:/proyectos/website - IntergraMAI/webMai/~/ng-recaptcha/forms.js
// module id = ../../../../ng-recaptcha/forms.js
// module chunks = 3